import { gql } from '@apollo/client';

export const DELETE_ACTIVITY = gql`
  mutation deleteActivity($id: ID!) {
    activity: deleteActivityById(id: $id) {
      id
      name
    }
  }
`;
